import React, { useRef } from 'react';
import NavigationBar from '../parts/navigation/NavigationBar';
import GoBackButton from './GoBackButton';
import utils from '../helpers/utils';
import PrintHeader from './PrintHeader';
import Sidebar from '../parts/menu/Sidebar';
import { Row } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa6';
import Tooltip from './tooltip/Tooltip';
import GlobalLoader from './loader/GlobalLoader';

const CustomContainer = (props) => {
  const contentRef = useRef(null);

  return (
    <div id="page-wrapper" className={utils.isToggled() ? 'toggled' : ''}>
      <NavigationBar printRef={contentRef} />

      <GlobalLoader/>
      <div className="d-flex min-vh-100">
        {/* Sidebar */}
        <Sidebar />

        {/* Main content */}
        <div className="flex-grow-1 d-flex flex-column" id="content-wrapper">
          <div
            ref={contentRef}
            className={`${props.wrapper}-wrapper ${props.className}`}
          >
            <div className="container-fluid p-0 d-flex flex-column">
              <PrintHeader />

              {props.back && (
                <div>
                  <GoBackButton />
                </div>
              )}

              {/* Sticky Header */}
              <div
                className={`${props.miniNavClassName} align-items-center sticky-top top-70 bg-white py-4 px-3`}
              >
                {props.title && (

                  <h4 className="text-dark mb-0">

                    {props.parent && props.parent}
                    {props.title}
                  </h4>
                )}
                {props.subtitle && (
                  <h6 className="text-muted ms-auto pt-1 mb-0">
                    {props.subtitle}
                  </h6>
                )}
              </div>

              <Row className={props.rowClass || ''} id="content-row">
                {props.enableReady && props.ready && props.children}
                {!props.enableReady && props.children}
              </Row>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomContainer;
